import styled from "styled-components";
import { useState, useEffect } from "react";
import { updateObject } from "../../../../../../utils/object";
import FormStringInput from "../../../../../../components/FormControls/FormStringInput";
import FormCheckBox from "../../../../../../components/FormControls/FormCheckBox";
import FormSelectWithLabel from "../../../../../../components/FormControls/FormSelectWithLabel";
import FormSelect from "../../../../../../components/FormControls/FormSelect";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../../components/FormControls/SecondaryButton";
import WarningButton from "../../../../../../components/FormControls/WarningButton";
import request from "../../../../../../api/request";
import MessageBox from "../../../../../../components/MessageBox";
import FormPasswordInput from "../../../../../../components/FormControls/FormPasswordInput";
import { NotificationManager } from 'react-notifications';

const StyledMainBranchSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 543px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

const LogoUploadRow = styled.div`
    display: flex;
    align-items: center;
    margin-top: 15px;
    gap: 20px;
`;

const LogoUploadLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const LogoFileInputLabel = styled.label`
    display: inline-block;
    cursor: pointer;
    background-color: ${(props) => props.theme.color.primaryblue || '#1a73e8'};
    color: white;
    font-size: 12px;
    padding: 6px 14px;
    border-radius: 3px;
    user-select: none;
    width: fit-content;
    &:hover {
        opacity: 0.85;
    }
`;

const LogoHiddenInput = styled.input`
    display: none;
`;

const LogoFileName = styled.span`
    font-size: 11px;
    color: ${(props) => props.theme.color.gray};
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const LogoButtonRow = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 4px;
`;

const LogoPreviewBox = styled.div`
    width: 120px;
    height: 80px;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f9f9f9;
    flex-shrink: 0;
`;

const LogoPreviewImg = styled.img`
    max-width: 118px;
    max-height: 78px;
    object-fit: contain;
`;

const LogoNoImage = styled.span`
    font-size: 11px;
    color: #aaa;
`;

function MainBranchSettings(props) {

    const {branches, selectedBranch, regionsList, isAddMode, setIsAddMode, refreshBranchesCallback} = props;

    let currentYear = new Date().getFullYear();
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [branchType, setBranchType] = useState(1);
    const [branchCommitteeCode, setBranchCommitteeCode] = useState('');
    const [currencyCode, setCurrencyCode] = useState('GBP');
    const [divisionCode, setDivisionCode] = useState('');
    const [parentBranchName, setParentBranchName] = useState('');
    const [branchName, setBranchName] = useState('');
    const [currentAccountingYear, setCurrentAccountingYear] = useState(currentYear);
    const [debtorCreditor, setDebtorCreditor] = useState(false);
    const [vatProcessingType, setVatProcessingType] = useState(0);
    const [lastYearEnd, setLastYearEnd] = useState(currentYear);
    const [lastYearEndStatus, setLastYearEndStatus] = useState(0);
    const [region, setRegion] = useState(null);

    const [isEFilingEnabled, setIsEFilingEnabled] = useState(false);
    const [vatRegistrationNo, setVatRegistrationNo] = useState('');
    const [useVATAnnualAccountingScheme, setUseVATAnnualAccountingScheme] = useState(false);
    const [governmentGatewayID, setGovernmentGatewayID] = useState('');
    const [governmentGatewayPassword, setGovernmentGatewayPassword] = useState('');
    const [eFilingTitle, setEFilingTitle] = useState('Mr.');
    const [eFilingSurname, setEFilingSurname] = useState('');
    const [eFilingForename, setEFilingForename] = useState('');
    const [eFilingPhone, setEFilingPhone] = useState('');
    const [eFilingEmail, setEFilingEmail] = useState('');
    const [eFilingFax, setEFilingFax] = useState('');
    
    const [needsValidation, setNeedsValidation] = useState(false);
    const [branchesList, setBranchesList] = useState([]);
    const [logoImage, setLogoImage] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [savedLogoPreview, setSavedLogoPreview] = useState(null);

    let branchTypes = ['Branch', 'Sub-Branch'];
    let vatProcessingTypes = ['Not VAT Registered', 'Accrual Accounting', 'Cash Accounting'];
    let lastYearEndStatusStrings = ['None', 'Signed off by Treasurer', 'Signed off by Auditor'];
    
    let years = [''];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    let callingTitles = ['Mr.', 'Mrs.', 'Miss.', 'Ms.', 'Dr.', 'Prof.', 'Sir', 'The Rev.', 'The Hon.'];

    const branchTypeStringToInt = (branchTypeStr) => {
        if (branchTypeStr === 'Branch') {
            return 1;
        } else {
            return 2;
        }
    }

    const vatProcessingTypeStringToInt = (str) => {
        let ret = vatProcessingTypes.findIndex((e, idx) => {
            return e === str;
        });
        if (ret) return ret;
        else return 0;
    }

    const lastYearEndStatusStringToInt = (str) => {
        let ret = lastYearEndStatusStrings.findIndex((e, idx) => {
            return e === str;
        });
        if (ret) return ret;
        else return 0;
    }

    const regionCodeToRegionName = (rCode) => {
        if (!rCode) return 'None';

        let r = regionsList.find((e) => e.RegionCode === rCode);
        if (r) return r.RegionName;
        else return 'None';
    }

    const regionNameToRegionCode = (rName) => {
        let r = regionsList.find((e) => e.RegionName === rName);
        if (r) return r.RegionCode;
        else return null;
    }

    const onChangeBranchType = (e) => {
        let bType = branchTypeStringToInt(e.target.value);
        setBranchType(bType);
        if (isAddMode) {
            setDivisionCode(bType === 1 ? '00001' : '');
        }
    }

    const onChangeParentBranchName = (e) => {
        let parentBranch = branches.find((b) => {
            return b.RecordName === e.target.value;
        });
        setBranchCommitteeCode(parentBranch.BranchCommitteeCode);
        setParentBranchName(e.target.value);
    }

    const onSaveChanges = async () => {
        if (branchCommitteeCode === '' || divisionCode === '' || branchName === '' || region === null || (isEFilingEnabled && vatRegistrationNo.length !== 9)) {
            setNeedsValidation(true);
        } else 
        {
            setIsSaving(true);
            let saveData = {};
            if (isAddMode) {
                saveData.DivisionCode = divisionCode;
                saveData.CurrentAccountingYear = currentAccountingYear ? currentAccountingYear : null;
                saveData.LastYearEndYear = lastYearEnd === '' || lastYearEnd === 0 ? null : lastYearEnd;
                saveData.LastYearEndStatus = lastYearEndStatus;
            }
            saveData.RecordType = branchType;
            saveData.BranchCommitteeCode = branchCommitteeCode;
            saveData.RecordName = branchName;
            saveData.CurrencyCode = currencyCode;
            saveData.DebtorCreditor = debtorCreditor;
            saveData.VATProcessingType = vatProcessingType;
            saveData.EFilingEnabled = isEFilingEnabled;
            saveData.VATRegistrationNo = vatRegistrationNo.length ? vatRegistrationNo : null;
            saveData.VATAnnualAccountingScheme = useVATAnnualAccountingScheme;
            saveData.EFilingSenderID = governmentGatewayID.length ? governmentGatewayID : null;
            saveData.EFilingPassword = governmentGatewayPassword.length ? governmentGatewayPassword : null;
            saveData.EFilingContactTitle = eFilingTitle;
            saveData.EFilingContactSurname = eFilingSurname.length ? eFilingSurname : null;
            saveData.EFilingContactForenames = eFilingForename.length ? eFilingForename : null;
            saveData.EFilingContactTelephone = eFilingPhone.length ? eFilingPhone : null;
            saveData.EFilingContactEMail = eFilingEmail.length ? eFilingEmail : null;
            saveData.EFilingContactFax = eFilingFax.length ? eFilingFax : null;
            saveData.RegionCode = region;

            const resp = (await request('database', isAddMode ? 'createBranch' : 'updateBranch', [saveData]));
            if (resp.ok && refreshBranchesCallback) {
                // If a new logo file was selected, upload it as part of saving
                if (logoImage) {
                    const logoResp = await request('database', 'uploadLogo', [branchCommitteeCode, logoImage]);
                    if (logoResp.ok) {
                        setSavedLogoPreview(logoPreview);
                        setLogoImage(null);
                    } else {
                        NotificationManager.error(logoResp.data || 'Logo upload failed');
                    }
                }
                refreshBranchesCallback(branchCommitteeCode, branchType);
                NotificationManager.success(isAddMode ? 'Created' : 'Updated' + ' branch');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsSaving(false);
            setIsAddMode(false);
        }
    };

    const deleteBranch = async () => {
        setShowMessageBox(false);

        setIsDeleting(true);
        let deleteData = {};
        deleteData.RecordType = branchType;
        deleteData.RecordName = branchName;
        deleteData.BranchCommitteeCode = branchCommitteeCode;
        const resp = (await request('database', 'deleteBranch', [deleteData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback();
            NotificationManager.success('Branch deleted');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeleting(false);
    }

    const onLogoFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setLogoImage(file);
        setLogoPreview(URL.createObjectURL(file));
    };

    const onRevertLogo = () => {
        setLogoImage(null);
        setLogoPreview(savedLogoPreview);
    };

    const onDeleteLogo = async () => {
        const resp = await request('database', 'removeLogo', [branchCommitteeCode]);
        if (resp.ok) {
            setLogoImage(null);
            setLogoPreview(null);
            setSavedLogoPreview(null);
            NotificationManager.success('Logo removed');
        } else {
            NotificationManager.error(resp.data || 'Failed to remove logo');
        }
    };

    useEffect(() => {
        if (!isAddMode && selectedBranch) {
            setNeedsValidation(false);
            setBranchType(selectedBranch.RecordType ? selectedBranch.RecordType : 1);
            setBranchCommitteeCode(selectedBranch.BranchCommitteeCode ? selectedBranch.BranchCommitteeCode : '');
            setDivisionCode(selectedBranch.DivisionCode? selectedBranch.DivisionCode : '');
            setBranchName(selectedBranch.RecordName ? selectedBranch.RecordName : '');
            setCurrentAccountingYear(selectedBranch.CurrentAccountingYear ? selectedBranch.CurrentAccountingYear : '');
            setDebtorCreditor(selectedBranch.DebtorCreditor ? selectedBranch.DebtorCreditor : false);
            setVatProcessingType(selectedBranch.VATProcessingType ? selectedBranch.VATProcessingType : 0);
            setIsEFilingEnabled(selectedBranch.EFilingEnabled ? selectedBranch.EFilingEnabled : false);
            setVatRegistrationNo(selectedBranch.VATRegistrationNo ? selectedBranch.VATRegistrationNo : '');
            setUseVATAnnualAccountingScheme(selectedBranch.VATAnnualAccountingScheme ? selectedBranch.VATAnnualAccountingScheme : false);
            setGovernmentGatewayID(selectedBranch.EFilingSenderID ? selectedBranch.EFilingSenderID : '');
            setGovernmentGatewayPassword(selectedBranch.EFilingPassword ? selectedBranch.EFilingPassword : '');
            setEFilingTitle(selectedBranch.EFilingContactTitle ? selectedBranch.EFilingContactTitle : '');
            setEFilingSurname(selectedBranch.EFilingContactSurname ? selectedBranch.EFilingContactSurname : '');
            setEFilingForename(selectedBranch.EFilingContactForenames ? selectedBranch.EFilingContactForenames : '');
            setEFilingPhone(selectedBranch.EFilingContactTelephone ? selectedBranch.EFilingContactTelephone : '');
            setEFilingEmail(selectedBranch.EFilingContactEMail ? selectedBranch.EFilingContactEMail : '');
            setEFilingFax(selectedBranch.EFilingContactFax ? selectedBranch.EFilingContactFax : '');
            setLastYearEnd(selectedBranch.LastYearEndYear ? selectedBranch.LastYearEndYear : 0);
            setLastYearEndStatus(selectedBranch.LastYearEndStatus ? selectedBranch.LastYearEndStatus : 0);
            setRegion(selectedBranch.RegionCode ? selectedBranch.RegionCode : null);
            // Load existing logo preview if stored
            setLogoImage(null);
            setLogoPreview(selectedBranch.LogoImage
                ? `data:image/png;base64,${selectedBranch.LogoImage}`
                : null);
            setSavedLogoPreview(selectedBranch.LogoImage
                ? `data:image/png;base64,${selectedBranch.LogoImage}`
                : null);
            if (selectedBranch.RecordType === 2) {
                let parentBranch = branches.find((b) => {
                    return b.BranchCommitteeCode === selectedBranch.BranchCommitteeCode && b.RecordType === 1;
                });
                setParentBranchName(parentBranch.RecordName);
            }
        }
        if (isAddMode) {
            setNeedsValidation(false);
            setBranchType(1);
            setBranchCommitteeCode('');
            setDivisionCode(branchType === 1 ? '00001' : '');
            setParentBranchName('');
            setBranchName('');
            setCurrentAccountingYear(currentYear);
            setDebtorCreditor(false);
            setVatProcessingType(0);
            setIsEFilingEnabled(false);
            setVatRegistrationNo('');
            setUseVATAnnualAccountingScheme(false);
            setGovernmentGatewayID('');
            setGovernmentGatewayPassword('');
            setEFilingTitle('Mr.');
            setEFilingSurname('');
            setEFilingForename('');
            setEFilingPhone('');
            setEFilingEmail('');
            setEFilingFax('');
            setLastYearEnd(0);
            setLastYearEndStatus(0);
            setRegion(null);
            setLogoImage(null);
            setLogoPreview(null);
            setSavedLogoPreview(null);
        }
        
        let brnchList = [''];
        for (let i = 0; i < branches.length; i ++) {
            brnchList.push(branches[i].RecordName);
        }
        setBranchesList(brnchList);
    }, [selectedBranch, isAddMode, branches]);

    return (
        <StyledMainBranchSettings>
            <WhiteBoard>
                <Title>Main details</Title>
                <div style={{display:'flex'}}>
                    <FormSelectWithLabel label='Type' items={branchTypes} value={branchTypes[branchType-1]} disabled={!isAddMode} onChange={(e) => onChangeBranchType(e)} style={{width:290, height:35, paddingLeft:13}}></FormSelectWithLabel>
                    {branchType===1 && <FormStringInput label='Code(s)' value={branchCommitteeCode} validated={needsValidation && branchCommitteeCode === '' ? false : undefined} onChange={(val) => setBranchCommitteeCode(val)} disabled={!isAddMode} inputStyle={{width:100}} style={{marginLeft: 15}}></FormStringInput>}
                {branchType===2 && <FormStringInput label='Code(s)' value={divisionCode} validated={needsValidation && divisionCode === '' ? false : undefined} onChange={(val) => setDivisionCode(val)} disabled={!isAddMode} inputStyle={{width:100}} style={{marginLeft: 15}}></FormStringInput>}
                </div>
                {branchType===2 &&
                <div style={{display:'flex'}}>
                    <FormStringInput label='Branch Code' value={branchCommitteeCode} validated={needsValidation && branchCommitteeCode === '' ? false : undefined} disabled={true} onChange={(val) => setBranchCommitteeCode(val)} inputStyle={{width:100}}></FormStringInput>
                    <FormSelectWithLabel label='Branch' items={branchesList} value={parentBranchName} disabled={!isAddMode} validated={needsValidation && parentBranchName === '' ? false : undefined} onChange={(e) => onChangeParentBranchName(e)} style={{width:290, height:35, paddingLeft:13, marginLeft:15}} labelStyle={{marginLeft:15}}></FormSelectWithLabel>
                </div>}
                <div style={{display:'flex'}}>
                    <FormStringInput label='Branch name' required={true} value={branchName} validated={needsValidation && branchName === '' ? false : undefined} onChange={(val) => setBranchName(val)} inputStyle={{width:290, height:35}}></FormStringInput>
                    <FormSelectWithLabel label='Year' items={years} value={currentAccountingYear} disabled={!isAddMode} onChange={(e) => setCurrentAccountingYear(e.target.value)} style={{width:100, height:35, marginLeft:15, paddingLeft:13}} labelStyle={{marginLeft:15}}></FormSelectWithLabel>
                </div>
                <FormCheckBox label='Enable Debtors / Creditors' checked={debtorCreditor} onCheck={(val) => setDebtorCreditor(val)} style={{marginTop:15}}></FormCheckBox>
                <div style={{display:'flex'}}>
                    <FormSelectWithLabel label='VAT basis' items={vatProcessingTypes} value={vatProcessingTypes[vatProcessingType]} onChange={(e) => setVatProcessingType(vatProcessingTypeStringToInt(e.target.value))} style={{width:290, height:35, paddingLeft:13}}></FormSelectWithLabel>
                    {vatProcessingType !== 0 && <FormCheckBox label='Online VAT submissions' checked={isEFilingEnabled} onCheck={(val) => setIsEFilingEnabled(val)} style={{marginTop:15, marginLeft:15}}></FormCheckBox>}
                </div>

                {vatProcessingType !== 0 && <div style={{marginTop:30}}>
                    <Title>Online VAT submission information</Title>
                    <div style={{display:'flex'}}>
                        <FormStringInput label='VAT registration number' value={vatRegistrationNo} validated={needsValidation && isEFilingEnabled && vatRegistrationNo.length !== 9 ? false : undefined} onChange={(val) => setVatRegistrationNo(val)} inputStyle={{width:255, height:35}}></FormStringInput>
                        <FormCheckBox label='VAT Annual accounting scheme' checked={useVATAnnualAccountingScheme} onCheck={(val) => setUseVATAnnualAccountingScheme(val)} style={{marginTop:15, marginLeft:20}}></FormCheckBox>
                    </div>
                    <div style={{display:'flex'}}>
                        <FormStringInput label='Government gateway ID' value={governmentGatewayID} onChange={(val) => setGovernmentGatewayID(val)} inputStyle={{width:255, height:35}}></FormStringInput>
                        <FormPasswordInput label='Government gateway password' value={governmentGatewayPassword} onChange={(val) => setGovernmentGatewayPassword(val)} inputStyle={{width:255, height:35}} style={{marginLeft:20}}></FormPasswordInput>
                    </div>
                    <div style={{display:'flex', paddingTop:10}}>
                        <FormSelectWithLabel label='Title' items={callingTitles} value={eFilingTitle} onChange={(e) => setEFilingTitle(e.target.value)} style={{width:150, height:35, paddingLeft:13}}></FormSelectWithLabel>
                        <FormStringInput label='Surname' value={eFilingSurname} onChange={(val) => setEFilingSurname(val)} inputStyle={{width:176, height:35}} style={{marginLeft:15}}></FormStringInput>
                        <FormStringInput label='Forename' value={eFilingForename} onChange={(val) => setEFilingForename(val)} inputStyle={{width:176, height:35}} style={{marginLeft:15}}></FormStringInput>
                    </div>
                    <div style={{display:'flex'}}>
                        <FormStringInput label='Telephone' value={eFilingPhone} onChange={(val) => setEFilingPhone(val)} inputStyle={{width:150, height:35}}></FormStringInput>
                        <FormStringInput label='Email address' value={eFilingEmail} onChange={(val) => setEFilingEmail(val)} inputStyle={{width:176, height:35}} style={{marginLeft:15}}></FormStringInput>
                        <FormStringInput label='Other' value={eFilingFax} onChange={(val) => setEFilingFax(val)} inputStyle={{width:176, height:35}} style={{marginLeft:15}}></FormStringInput>
                    </div>
                </div>}


                <Title style={{paddingTop:30}}>Other details</Title>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Last end year' value={lastYearEnd} disabled={!isAddMode} onChange={(val) => setLastYearEnd(val)} inputStyle={{width:100, height:35}}></FormStringInput>
                    <FormSelect items={lastYearEndStatusStrings} value={lastYearEndStatusStrings[lastYearEndStatus]} disabled={!isAddMode} onChange={(e) => setLastYearEndStatus(lastYearEndStatusStringToInt(e.target.value))} style={{width:290, height:35, marginLeft:15, paddingLeft:13, marginTop:'auto'}}></FormSelect>
                </div>
                {<FormSelectWithLabel
                    label='Region'
                    items={['None', ...regionsList.map((e) => e.RegionName)]}
                    value={regionCodeToRegionName(region)}
                    onChange={(e) => setRegion(regionNameToRegionCode(e.target.value))}
                    validated={needsValidation && region === null ? false : undefined}
                    style={{width:405, height:35, paddingLeft:13}}>
                </FormSelectWithLabel>}

                <Title style={{paddingTop:20}}>Custom invoice logo</Title>
                <LogoUploadRow>
                    <LogoUploadLeft>
                        <LogoFileInputLabel>
                            Choose image
                            <LogoHiddenInput
                                type="file"
                                accept="image/png, image/jpeg, image/gif"
                                onChange={onLogoFileChange}
                            />
                        </LogoFileInputLabel>
                        {logoImage && (
                            <LogoFileName>{logoImage.name}</LogoFileName>
                        )}
                        {logoImage && savedLogoPreview && (
                            <LogoButtonRow>
                                <SecondaryButton
                                    caption='Revert'
                                    onClick={onRevertLogo}
                                    style={{width:80}}
                                />
                            </LogoButtonRow>
                        )}
                        {!logoImage && savedLogoPreview && (
                            <LogoButtonRow>
                                <WarningButton
                                    caption='Delete logo'
                                    onClick={onDeleteLogo}
                                    style={{width:100}}
                                />
                            </LogoButtonRow>
                        )}
                    </LogoUploadLeft>
                    <LogoPreviewBox>
                        {logoPreview
                            ? <LogoPreviewImg src={logoPreview} alt="Logo preview" />
                            : <LogoNoImage>No logo</LogoNoImage>
                        }
                    </LogoPreviewBox>
                </LogoUploadRow>
            </WhiteBoard>
            <div>
                {!isAddMode && <WarningButton caption='Delete branch' isLoading={isDeleting} onClick={() => setShowMessageBox(true)} style={{width:120}}></WarningButton>}
                {isAddMode && <SecondaryButton caption='Cancel' onClick={() => setShowMessageBox(true)} style={{width:100}}></SecondaryButton>}
                <PrimaryButton caption='Save changes' isLoading={isSaving} onClick={() => onSaveChanges()} style={{width:150, float:'right'}}></PrimaryButton>
            </div>

            { showMessageBox && <MessageBox
                text = {isAddMode ? 'Are you sure cancel?' : 'Are you sure you want to delete this branch?'}
                yesText = {isAddMode ? 'Cancel' : 'Delete branch'}
                noText = {isAddMode ? 'No' : 'Cancel'}
                isWarning = {!isAddMode}
                handleClickYes = {() => {
                        if (isAddMode) {
                            if (setIsAddMode) {
                                setIsAddMode(false);
                                setShowMessageBox(false);
                            }
                        } else {
                            deleteBranch();
                        }
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
        </StyledMainBranchSettings>
    )
}

export default MainBranchSettings;